import {
  FC,
  forwardRef,
  type MutableRefObject,
  type Ref,
} from 'react'
import MaskedInput from 'react-text-mask'
import { TextField } from '../../..'
import { CustomMaskedInputProps, TextMaskCustomProps } from './types'

function applyInputRef<T>(ref: Ref<T> | undefined, value: T | null): void {
  if (typeof ref === 'function') {
    ref(value)
  } else if (ref != null && typeof ref === 'object' && 'current' in ref) {
    ;(ref as MutableRefObject<T | null>).current = value
  }
}

const TextMaskCustom = forwardRef<HTMLInputElement | null, TextMaskCustomProps>(
  function TextMaskCustom(props, ref) {
    const { mask, inputRef, ...other } = props

    return (
      <MaskedInput
        {...other}
        ref={(instance: any) => {
          const el = (instance?.inputElement as HTMLInputElement | undefined) ?? null
          applyInputRef(ref, el)
          applyInputRef(inputRef, el)
        }}
        mask={mask}
        placeholderChar={'\u2000'}
        showMask={false}
      />
    )
  }
)

const CustomMaskedInput: FC<CustomMaskedInputProps> = (props) => {
  const { mask, ...rest } = props

  return (
    <TextField
      InputProps={{
        inputProps: { mask },
        inputComponent: TextMaskCustom as any
      }}
      {...(rest as any)}
    />
  )
}

export default CustomMaskedInput
